<template>
  <div ref="companyEl" class="py-10 md:py-[10vw] relative w-full md:h-full flex flex-col items-stretch px-3 md:px-0">
    <div class="flex-grow relative w-full h-full container-1 mx-auto">
      <div class="lg:max-w-[60vw] mx-auto lg:space-y-10 company-details">
        <div class="text-ellie-blue whitespace-pre-line font-semibold text-5xl md:text-[4.167vw] big-screen:text-[6vw] leading-[1.2] py-8 md:py-0">
          <h1 class="">
            <div class="animate-company-title opacity-0 translate-y-[20%] inline-block">{{ "Motion—" }}</div>
            <div class="animate-company-title opacity-0 translate-y-[20%] inline-block ml-0 md:ml-4"></div>
            <div class="animate-company-title opacity-0 translate-y-[20%] inline-block">{{ "Designed" }}</div>
          </h1>
          <h1 class="">
            <div class="animate-company-title opacity-0 translate-y-[20%] inline-block">{{ "to" }}</div>
            <div class="animate-company-title opacity-0 translate-y-[20%] inline-block ml-0 md:ml-4"></div>
            <div class="animate-company-title opacity-0 translate-y-[20%] inline-block">{{ "Empower" }}</div>
            <div class="animate-company-title opacity-0 translate-y-[20%] inline-block ml-0 md:ml-4"></div>
            <div class="animate-company-title opacity-0 translate-y-[20%] inline-block">{{ "Brands" }}</div>
          </h1>
        </div>
        <div class="space-y-6 md:space-y-9">
          <p class="animate-content-paragraph opacity-0 translate-y-[20%] flex gap-1 flex-wrap justify-start text-ellie-black md:font-semibold text-base md:text-[1.3w] big-screen:text-[1.5vw] leading-[1.5]">Ellie Creative Works is a team of seasoned creatives specialising in motion design that helps brands speak with clarity. As your ally, we’re here to create delightful encounters that leave lasting impressions.</p>
          <p class="animate-content-paragraph opacity-0 translate-y-[20%] flex gap-1 flex-wrap justify-start text-ellie-black md:font-semibold text-base md:text-[1.3w] big-screen:text-[1.5vw] leading-[1.5]">Shall we work together to create something they'll all remember?</p>
          <NuxtLink to="/about" @mouseenter="toggleHover(true)" @mouseleave="toggleHover(false)" class="animate-content-paragraph opacity-0 w-fit translate-y-[20%] block text-white uppercase border-[0.05vw] border-ellie-blue bg-ellie-blue rounded-full text-sm px-8 py-2 md:px-[1.5vw] md:py-[0.8vw] text-[1.3w] big-screen:text-[1vw] tracking-[0.01vw] hover:bg-opacity-80 hover:text-white transition-colors duration-300">
            about us
          </NuxtLink>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
const isM = useMediaQuery('(min-width: 768px)');
const mainStore = useMainStore();
const { $anime, $gsap, $ScrollTrigger } = useNuxtApp();

const init = () => {
  $gsap.to('.animate-company-title', {
    scrollTrigger: {
      trigger: '.trigger-animate-company',
      start: '-30% -30%',
      end: '50% 50%',
      scrub: true,
    },
    stagger: 0.1,
    y: 0,
    opacity: 1,
    ease: 'power1.out',
  });

  $gsap.to('.animate-content-paragraph', {
    scrollTrigger: {
      trigger: '.trigger-animate-company',
      start: isM.value ? '20% 20%' : '40% 40%',
      end: isM.value ? '70% 70%' : '50% 50%',
      scrub: true,
    },
    stagger: 0.1,
    opacity: 1,
    y: 0,
    ease: 'power1.out',
  });
};

const toggleHover = (isHover, type = 'default') => {
  const payload = { isHover, type };
  mainStore.toggleTrackingMouse(payload);
};

onMounted(() => {
  nextTick(() => {
    const to = setTimeout(() => {
      init();
      clearTimeout(to);
    }, 1000);
  });
});

</script>
